import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { isAdmin } from '../utils/adminAccess';

interface AdminRouteGuardProps {
  user?: any;
  children: React.ReactNode;
}

const AdminRouteGuard: React.FC<AdminRouteGuardProps> = ({ user, children }) => {
  const location = useLocation();
  const userIsAdmin = isAdmin(user);

  const adminPages = ['/admin', '/admin/users', '/admin/coffee-chats', '/admin/projects', '/admin/settings', '/admin/undelivered-emails'];
  const isAdminPage = adminPages.some(page => location.pathname === page);

  if (isAdminPage && !userIsAdmin) {
    return <Redirect to="/" />;
  }

  if (userIsAdmin && !isAdminPage) {
    return <Redirect to="/admin" />;
  }

  return <>{children}</>;
};

export default AdminRouteGuard;